const SELF_CITIES_LINKS = [
    {
        name: "Houston Storage",
        link: "https://www.storage.com/self-storage/texas/houston/"
    },
    {
        name: "San Antonio Storage",
        link: "https://www.storage.com/self-storage/texas/san-antonio/"
    },
    {
        name: "Columbus Storage",
        link: "https://www.storage.com/self-storage/ohio/columbus/"
    },
    {
        name: "Brooklyn Storage",
        link: "https://www.storage.com/self-storage/new-york/brooklyn/"
    },
    {
        name: "Atlanta Storage",
        link: "https://www.storage.com/self-storage/georgia/atlanta/"
    },
    {
        name: "Phoenix Storage",
        link: "https://www.storage.com/self-storage/arizona/phoenix/"
    },
    {
        name: "Los Angeles Storage",
        link: "https://www.storage.com/self-storage/california/los-angeles/"
    },
    {
        name: "Austin Storage",
        link: "https://www.storage.com/self-storage/texas/austin/"
    },
    {
        name: "Denver Storage",
        link: "https://www.storage.com/self-storage/colorado/denver/"
    },
    {
        name: "Tampa Storage",
        link: "https://www.storage.com/self-storage/florida/tampa/"
    },
    {
        name: "Dallas Storage",
        link: "https://www.storage.com/self-storage/texas/houston/"
    },
    {
        name: "Bronx Storage",
        link: "https://www.storage.com/self-storage/new-york/bronx/"
    },
    {
        name: "Charlotte Storage",
        link: "https://www.storage.com/self-storage/north-carolina/charlotte/"
    },
    {
        name: "San Jose Storage",
        link: "https://www.storage.com/self-storage/california/san-jose/"
    },
    {
        name: "Philadelphia Storage",
        link: "https://www.storage.com/self-storage/pennsylvania/philadelphia/"
    },
    {
        name: "Las Vegas Storage",
        link: "https://www.storage.com/self-storage/nevada/las-vegas/"
    },
    {
        name: "Oklahoma City Storage",
        link: "https://www.storage.com/self-storage/oklahoma/oklahoma-city/"
    },
    {
        name: "Sacramento Storage",
        link: "https://www.storage.com/self-storage/california/sacramento/"
    },
    {
        name: "Miami Storage",
        link: "https://www.storage.com/self-storage/florida/miami/"
    },
    {
        name: "Jacksonville Storage",
        link: "https://www.storage.com/self-storage/florida/jacksonville/"
    },
    {
        name: "Chicago Storage",
        link: "https://www.storage.com/self-storage/illinois/chicago/"
    },
    {
        name: "Portland Storage",
        link: "https://www.storage.com/self-storage/oregon/portland/"
    },
    {
        name: "Fort Worth Storage",
        link: "https://www.storage.com/self-storage/texas/fort-worth/"
    },
    {
        name: "San Diego Storage",
        link: "https://www.storage.com/self-storage/california/san-diego/"
    },
    {
        name: "St Louis Storage",
        link: "https://www.storage.com/self-storage/missouri/st-louis/"
    },
    {
        name: "Baton Rouge Storage",
        link: "https://www.storage.com/self-storage/louisiana/baton-rouge/"
    },
    {
        name: "Fort Myers Storage",
        link: "https://www.storage.com/self-storage/florida/fort-myers/"
    },
    {
        name: "Orlando Storage",
        link: "https://www.storage.com/self-storage/florida/orlando/"
    },
    {
        name: "Washington Storage",
        link: "https://www.storage.com/self-storage/district-of-columbia/washington/"
    },
    {
        name: "Kansas City Storage",
        link: "https://www.storage.com/self-storage/missouri/kansas-city/"
    },
    {
        name: "Nashville Storage",
        link: "https://www.storage.com/self-storage/tennessee/nashville/"
    },
    {
        name: "Columbia Storage",
        link: "https://www.storage.com/self-storage/south-carolina/columbia/"
    },
    {
        name: "Queens Storage",
        link: "https://www.storage.com/self-storage/new-york/queens/"
    },
    {
        name: "Tucson Storage",
        link: "https://www.storage.com/self-storage/arizona/tucson/"
    },
    {
        name: "San Francisco Storage",
        link: "https://www.storage.com/self-storage/california/san-francisco/"
    },
    {
        name: "Raleigh Storage",
        link: "https://www.storage.com/self-storage/north-carolina/raleigh/"
    },
    {
        name: "Albuquerque Storage",
        link: "https://www.storage.com/self-storage/new-mexico/albuquerque/"
    },
    {
        name: "Baltimore Storage",
        link: "https://www.storage.com/self-storage/maryland/baltimore/"
    },
    {
        name: "Colorado Springs Storage",
        link: "https://www.storage.com/self-storage/colorado/colorado-springs/"
    },
    {
        name: "Cincinnati Storage",
        link: "https://www.storage.com/self-storage/ohio/cincinnati/"
    },
    {
        name: "Manhattan Storage",
        link: "https://www.storage.com/self-storage/new-york/manhattan/"
    },
    {
        name: "Richmond Storage",
        link: "https://www.storage.com/self-storage/virginia/richmond/"
    },
    {
        name: "Salt Lake City Storage",
        link: "https://www.storage.com/self-storage/utah/salt-lake-city/"
    },
    {
        name: "Fort Lauderdale Storage",
        link: "https://www.storage.com/self-storage/florida/fort-lauderdale/"
    },
    {
        name: "Pittsburgh Storage",
        link: "https://www.storage.com/self-storage/pennsylvania/pittsburgh/"
    },
    {
        name: "El Paso Storage",
        link: "https://www.storage.com/self-storage/texas/el-paso/"
    },
    {
        name: "Indianapolis Storage",
        link: "https://www.storage.com/self-storage/indiana/indianapolis/"
    },
    {
        name: "Memphis Storage",
        link: "https://www.storage.com/self-storage/tennessee/memphis/"
    }
];
 
export { SELF_CITIES_LINKS }
